import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../../js/stores/language.js';
import user from '../../../js/stores/user.js';
import car from '../../../js/stores/car.js';
import contact from '../../../js/stores/contact.js';
import carLoan from '../../../js/stores/car-loan.js';
function framework7Component(props, _ref) {
  var $h = _ref.$h,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var carLoanList = [];
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var loanList;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return carLoan.dispatch('getAllCarLoans');
        case 1:
          loanList = _context.sent;
          if (loanList.status !== undefined && loanList.status !== 200) console.log(loanList.data.messages.error);else carLoanList = loanList;
          $update();
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="car-loan-list">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">${locale.translate('loan.title')}</div>
    </div>
  </div>
  <div class="page-content">
    ${carLoanList.length > 0 && $h`
    <div class="block-title">${locale.translate('loan.lends')}</div>
    <div class="data-table">
      <table>
        <thead>
          <tr>
            <th class="label-cell">${locale.translate('loan.dashboard.carLoanTag')}</th>
            <th class="">${locale.translate('loan.dashboard.borrower')}</th>
            <th class="numeric-cell">${locale.translate('loan.dashboard.startDate')}</th>
            <th class="numeric-cell">${locale.translate('loan.dashboard.endDate')}</th>
            <th class="numeric-cell">${locale.translate('loan.dashboard.daysToBorrow')}</th>
            <th class="numeric-cell">${locale.translate('loan.dashboard.totalToPay')}</th>
            <th class="numeric-cell">${locale.translate('loan.dashboard.discounts')}</th>
            <th class="medium-only">${locale.translate('loan.dashboard.isGoingAbroad')}</th>
            <th class="medium-only">${locale.translate('general.status')}</th>
          </tr>
        </thead>
        <tbody>
        ${carLoanList.map((item) => $h`
          <tr>
            <td class="label-cell">${item.CarLoanTag}</td>
            <td class="">${item.BorrowerName}</td>
            <td class="numeric-cell">${item.CarLoanStartDate}</td>
            <td class="numeric-cell">${item.CarLoanEndDate}</td>
            <td class="numeric-cell">${item.DaysToBorrow}</td>
            <td class="numeric-cell">${item.TotalToPay}</td>
            <td class="numeric-cell">${item.Discounts}</td>
            <td class="medium-only">${item.IsGoingAbroad}</td>
            <td class="medium-only">${locale.translate(`loan.statusLabel.${item.CarLoanStatusId}`)}</td>
          </tr>
        `)}
        </tbody>
      </table>
    </div>
    `}
  </div>
</div>
`
    }
    ;
}
framework7Component.id = '333e7c3236';
export default framework7Component;